const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error'
};

/* ---------------------------------------------------------------
 * TEMPORARY HOTFIX - 2026-08-02
 * sections/figgy-color-picker-v4.liquid contains a stray character:
 *     var isPresaleAtc = false;f
 * The bare `f` throws "ReferenceError: f is not defined" inside
 * fcpAddToCart(), aborting the function right after the button is
 * set to "Adding..." - so Add to Cart freezes and never adds.
 * Declaring f globally makes that stray statement harmless.
 *
 * PROPER FIX: delete the stray `f` from figgy-color-picker-v4.liquid,
 * then delete this block.
 * --------------------------------------------------------------- */
if (!('f' in window)) { window.f = undefined; }
